import React from 'react';

export const NextIcon = () => (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="50" height="50" rx="25" fill="#757575" fillOpacity="0.25" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.6465 31.3535C21.4512 31.1583 21.4512 30.8417 21.6465 30.6464L27.2929 25L21.6465 19.3536C21.4512 19.1583 21.4512 18.8417 21.6465 18.6464C21.8417 18.4512 22.1583 18.4512 22.3536 18.6464L28.3536 24.6464C28.5488 24.8417 28.5488 25.1583 28.3536 25.3536L22.3536 31.3535C22.1583 31.5488 21.8417 31.5488 21.6465 31.3535Z"
            fill="#F5F5F5"
        />
    </svg>
);
